// extracted by mini-css-extract-plugin
export default {"modalWrapper":"styles_modalWrapper__IjWBC","btnBlock":"styles_btnBlock__qLI1A","mainBtn":"styles_mainBtn__Cp+9f"};